import { GetUsersMe200Response } from '@src/api/generated/user-api/api'

export const toAuthenticationType = (
  meResponse: GetUsersMe200Response
): AuthenticationResponseInterface => {
  return {
    id: meResponse.id,
    userName: meResponse.name,
    email: meResponse.email,
    organization: {
      id: meResponse.organizationId,
      name: meResponse.organizationName,
    },
    organizationId: meResponse.organizationId,
    organizationName: meResponse.organizationName,
    contracts: meResponse.contracts,
    isGeneralUser: meResponse.isGeneralUser,
    isOrganizationAdmin: meResponse.isOrganizationAdmin,
    isViewer: meResponse.isViewer,
    isBookkeeper: meResponse.isBookkeeper,
    isSystemAdmin: meResponse.isSystemAdmin,
    isTempPassword: meResponse.isTempPassword,
    roles: meResponse.roles,
    twoFactorAuthRegisterStatus: meResponse.twoFactorAuthRegisterStatus,
    smsPhoneNumber: meResponse.smsPhoneNumber,
    hasPayContract: meResponse.hasPayContract,
    hasCardContract: meResponse.hasCardContract,
    isJournalFeatureEnabled: meResponse.isJournalFeatureEnabled,
    freeeCompanyId: meResponse.freeeCompanyId,
    availableFeatures: meResponse.availableFeatures,
  }
}

type AuthenticationResponseInterface = {
  id: GetUsersMe200Response['id']
  userName: GetUsersMe200Response['name']
  email: GetUsersMe200Response['email']
  // TODO: Remove 'organization' property
  // This property is referenced by many codes in vue.
  organization: {
    id: GetUsersMe200Response['organizationId']
    name: GetUsersMe200Response['organizationName']
  }
  organizationId: GetUsersMe200Response['organizationId']
  organizationName: GetUsersMe200Response['organizationName']
  contracts: GetUsersMe200Response['contracts']
  isGeneralUser: GetUsersMe200Response['isGeneralUser']
  isOrganizationAdmin: GetUsersMe200Response['isOrganizationAdmin']
  isViewer: GetUsersMe200Response['isViewer']
  isBookkeeper: GetUsersMe200Response['isBookkeeper']
  isSystemAdmin: GetUsersMe200Response['isSystemAdmin']
  isTempPassword: GetUsersMe200Response['isTempPassword']
  roles: GetUsersMe200Response['roles']
  twoFactorAuthRegisterStatus: GetUsersMe200Response['twoFactorAuthRegisterStatus']
  smsPhoneNumber: GetUsersMe200Response['smsPhoneNumber']
  hasPayContract: GetUsersMe200Response['hasPayContract']
  hasCardContract: GetUsersMe200Response['hasCardContract']
  isJournalFeatureEnabled: GetUsersMe200Response['isJournalFeatureEnabled']
  freeeCompanyId: GetUsersMe200Response['freeeCompanyId']
  availableFeatures: GetUsersMe200Response['availableFeatures']
}
